import styled from "@emotion/styled"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

export const Wrapper = styled.div`
  position: relative;
  z-index: 9;
  margin-bottom: -96px;
  padding-top: 97px;

  @media (min-width: 768px) {
    //padding-top: 122px;
    margin-bottom: -128px;
  }

  @media (min-width: 1024px) {
    padding-top: 124px;
    margin-bottom: -124px;
    > section {
      border-top: 0;
    }
  }

  .section-wrapper {
    max-width: 1570px;
    margin: 0 auto;

    @media (min-width: 1024px) {
      padding: 0 25px;
    }
  }

  .revisit-cta {
    color: ${theme.wild.color.nova.brand.primary[100]};
  }
`

export const Banner = styled.div`
  padding: 16px;
  background: ${theme.wild.color.nova.base.solid[20]};
  border: 1px solid ${theme.wild.color.nova.transparency.black[20]};
  border-radius: 2px;

  @media (max-width: 1023px) {
    border-left: 0;
    border-right: 0;
  }
`

export const FloatWrapper = styled.div`
  position: absolute;
  z-index: 10;
  top: 97px;
  left: 0;
  right: 0;

  @media (min-width: 768px) {
    //top: 122px;
  }

  @media (min-width: 1024px) {
    border-top: 0;
    top: 124px;
  }

  > section {
    background: ${theme.wild.color.nova.base.solid[20]};
    border: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    border-radius: 2px;

    @media (max-width: 1023px) {
      border-left: 0;
      border-right: 0;
    }
  }
`

export const Tooltip = styled.div`
  position: absolute;
  right: 12px;
  top: -8px;
  transform: translate(20px, -100%);
  padding: 8px;
  border-radius: 2px;
  background: ${theme.wild.color.nova.base.white};
  width: 185px;
  text-align: center;
  box-shadow:
    0px 0px 20px 0px rgba(0, 0, 0, 0.05),
    0px 24px 38px 0px rgba(0, 0, 0, 0.03),
    0px 9px 46px 0px rgba(0, 0, 0, 0.03),
    0px 11px 15px 0px rgba(0, 0, 0, 0.03);

  &::before {
    content: "";
    position: absolute;
    right: 8px;
    bottom: -7px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid ${theme.wild.color.nova.base.white};
  }

  @media (min-width: 768px) {
    right: 0;

    &::before {
      right: 20px;
    }
  }
`
